export default __webpack_public_path__ + "static/media/stone-knight.fd11d2be.jpg";